import { useTranslation } from "react-i18next";
import { SettingsSection } from "@/components/SettingsSection";
import { SettingsRow } from "@/components/SettingsRow";
import { useBillingStatusQuery } from "@/features/billing/hooks/useBilling";
import type { SubscriptionProduct } from "@/features/billing/types";

export function PlanSection() {
  const { t } = useTranslation();
  const { data: status, isLoading } = useBillingStatusQuery();

  function productLabel(product: SubscriptionProduct) {
    return product === "CLOUD" ? t("billing.cloud") : t("billing.selfHostedPremium");
  }

  const label =
    status?.plan === "PAID" && status.subscriptionProduct
      ? `${t("plan.PAID")} · ${productLabel(status.subscriptionProduct)}`
      : status
        ? status.plan === "PAID"
          ? t("plan.PAID")
          : t("plan.FREE")
        : t("common.dash");

  const description =
    isLoading || !status
      ? t("common.loading")
      : status.plan === "PAID"
        ? t("billing.planDescription.PAID")
        : t("billing.planDescription.FREE");

  return (
    <SettingsSection title={t("billing.yourPlan")}>
      <SettingsRow label={label} description={description}>
        {null}
      </SettingsRow>
    </SettingsSection>
  );
}
